import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(public http: HttpClient) { }

  // searchAdminId(searchKey: string) {
  //   //const url = BASE_URL + '/admins' + '?id=["eq","' + searchKey + '"]';
  //   return this.http.get(url);
  // }

  // wakeUp() {

  //   //const url = BASE_URL_OLD + '/userstats';
  //   return this.http.get(url);

  // }
}
